"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Notifications/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _user = require('shared/selectors/user');
var _noticeBar = require('web/services/context/noticeBar');
var _hooks = require('web/services/hooks');

var _PageLayout = require('web/components/Settings/PageLayout'); var _PageLayout2 = _interopRequireDefault(_PageLayout);
var _Headings = require('web/components/Settings/Headings');
var _Form = require('web/components/Form');
var _Sections = require('./Sections');
var _Divider = require('web/components/Settings/Divider'); var _Divider2 = _interopRequireDefault(_Divider);






const NotificationsPage = ({
  gotoSettingsRoot, profileSettingsUrl,
}) => {
  const me = _hooks.useAppSelector.call(void 0, _user.selectCurrentUserWithMentionSettings)
  const { showNoticeBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const isCurrentUserLoading = me.NumberOfLogins === -1
  const [notificationSound, setNotificationSound] = _react.useState(me.Notification_Sound)
  const [suppressTeam, setSuppressTeam] = _react.useState.call(void 0, !!me.Suppress_Team_Mentions)
  const [suppressAll, setSuppressAll] = _react.useState.call(void 0, !!me.Suppress_All_Mentions)

  _react.useEffect.call(void 0, () => {
    setSuppressTeam(!!me.Suppress_Team_Mentions)
    setSuppressAll(!!me.Suppress_All_Mentions)
  }, [me.Suppress_Team_Mentions, me.Suppress_All_Mentions])

  // Optimistic toggle: flip the box now, and put it back with a warning if
  // the server rejects the change.
  const saveMentionSettings = (next) => {
    const previous = { team: suppressTeam, all: suppressAll }
    if (next.team !== undefined) setSuppressTeam(next.team)
    if (next.all !== undefined) setSuppressAll(next.all)
    return _actions2.default.setGlobalMentionNotificationSettings({
      SuppressTeamMentions: next.team === undefined ? suppressTeam : next.team,
      SuppressAllMentions: next.all === undefined ? suppressAll : next.all,
    }).catch(() => {
      if (next.team !== undefined) setSuppressTeam(previous.team)
      if (next.all !== undefined) setSuppressAll(previous.all)
      showWarningBar('An error occurred. Please try again later.')
    })
  }

  return (
    _react2.default.createElement(_PageLayout2.default, { title: "Notifications", onBack: gotoSettingsRoot, __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
      , _react2.default.createElement(_Headings.Subheader, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}, "Push Notifications" )
      , _react2.default.createElement(_Sections.DeviceSection, {
        userKey: me.UserKey,
        showNoticeBar: showNoticeBar,
        currentSoundUrl: notificationSound,
        onSoundUrlChange: setNotificationSound, __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}
      )
      , _react2.default.createElement(_Sections.MuteSection, {
        onSubmit: _actions2.default.setUserMuteUntil,
        muteUntil: me.Notification_MuteUntil, __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
      )
      ,  !isCurrentUserLoading &&
        _react2.default.createElement(_Sections.DNDSection, {
          onSubmitDND: _actions2.default.setGlobalNotificationDND,
          onDisableDND: _actions2.default.unsetGlobalNotificationDND,
          dndStartTime: me.Notification_DND_StartTime || null,
          dndEndTime: me.Notification_DND_EndTime || null,
          dndTimezone: me.Notification_DND_TimeZone || null, __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
        )
      
      , _react2.default.createElement(_Divider2.default, { className: "settings--notifications--divider", __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}} )
      , _react2.default.createElement(_Headings.Subheader, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}, "Offline Notifications" )
      , _react2.default.createElement(_Sections.EmailSection, {
        hasEmail: !!me.Email,
        hasPhone: !!me.PrimaryPhone,
        profileSettingsUrl: profileSettingsUrl,
        isSMSNotificationsOn: me.Notification_SMS,
        isEmailNotificationsOn: me.Notification_Emails,
        onTurnOnSMSNotifications: _actions2.default.enableNotificationSMS,
        onTurnOffSMSNotifications: _actions2.default.disableNotificationSMS,
        onTurnOnEmailNotifications: _actions2.default.enableNotificationEmails,
        onTurnOffEmailNotifications: _actions2.default.disableNotificationEmails, __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}
      )
      , _react2.default.createElement(_Divider2.default, { className: "settings--notifications--divider", __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}} )
      , _react2.default.createElement(_Headings.Subheader, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}, "Mention alerts" )
      , _react2.default.createElement(_Form.Toggle, {
        className: "settings--notifications--email-label",
        isChecked: suppressTeam,
        onChange: team => saveMentionSettings({ team }),
        label: "Mute team mentions"  ,
        hint: "No alerts in any chat when a team you're on is mentioned. Direct mentions of you still come through."                  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}}
      )
      , _react2.default.createElement(_Form.Toggle, {
        className: "settings--notifications--email-label",
        isChecked: suppressAll,
        onChange: all => saveMentionSettings({ all }),
        label: "Mute @all mentions"  ,
        hint: "No alerts in any chat when someone mentions @all."        , __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, NotificationsPage)
